<template>
  <span>
    <router-link :to="'/pricing/pricelisttemplates/' + id" v-if="userHasReadPermission(PermissionTypes.PricingPermissionTypes.priceListTemplate) && !disabled" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkPriceListTemplate',
  props: {
    id: Number,
    customerId: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    },
    disabled: Boolean
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
